import React, { PropsWithChildren, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

import { ErrorRoutes, RoleUser } from '@homesusa/core';
import { AuthCompanyContext } from '../providers';
import { Loading } from './loading.component';
import { useHasRole } from '../hooks';

export const PrivateRouteUserRole = ({
  allowedUserRoles: userRoles,
  children
}: PropsWithChildren<{
  allowedUserRoles?: RoleUser[];
}>): JSX.Element => {
  const navigate = useNavigate();
  const { userCompanies } = React.useContext(AuthCompanyContext);
  const { hasUserRole } = useHasRole();
  const [loading, setLoading] = React.useState(true);

  React.useLayoutEffect(() => {
    if (!userCompanies) {
      return;
    }
    if (userRoles && !hasUserRole(userRoles)) {
      navigate(ErrorRoutes.ForbiddenError, { replace: true });
      return;
    }
    if (hasUserRole([RoleUser.User]) && userCompanies.length <= 0) {
      navigate(ErrorRoutes.HasNotCompaniesError, { replace: true });
      return;
    }
    setLoading(false);
  }, [userCompanies, hasUserRole]);

  if (loading) {
    return <Loading />;
  }

  return <Fragment>{children}</Fragment>;
};
